import type { ListItem } from "../list.type";

import { useEffect } from "react";

import { useList } from "@/hooks/queries";

import { useListContext } from "../list.context";

import { formatListData } from "./list-fetcher.helper";

export const useListFetcherClassicHandler = <
  DataItem extends ListItem = ListItem,
  Metadata = unknown,
>() => {
  const {
    endpoint,
    withMetadata,
    fetchParams,
    enabled,
    neverStale,
    parentId,
    setListData,
  } = useListContext<DataItem, Metadata>();

  const { data, isLoading, isFetching } = useList<DataItem>(endpoint, {
    params: fetchParams,
    enabled,
    neverStale,
    rootId: parentId,
  });

  useEffect(() => {
    const listData = formatListData<DataItem, Metadata>({
      data,
      withMetadata,
      isLoading,
      isFetching,
    });

    setListData(listData);
  }, [data, isLoading, isFetching, withMetadata]);
};
